import type { FaireProductEntity } from "../../entity_types/product";

export const p_juz47f7xvv: FaireProductEntity = {
  token: "p_juz47f7xvv",
  type: "product",
  name: "I ❤️ Therapy Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/56e8882deedba32cd1cac98c07f7316f6b90caed8013ee0b7bc2002164eff4cc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/42b860aa531b5df017b8dce26e80d99001b2cbdffa8a5e2044a50fe4f6ca8897.jpeg",
    "https://cdn.faire.com/fastly/e5a3210389f0cf63217cfd4ebedef070e9bf34adcd86da04cd955f772edf6969.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/63b20cd78bbc3d5be414d9f1c459af85525f9e17c6a941c16f68ee3bb50ec4ac.jpeg",
    "https://cdn.faire.com/fastly/cf448b32c221c773c6b527064450e21aab5708203e8e8aa4b317678dc95b0802.jpeg"
  ],
  priceDollars: 6.75,
  description: "Some people want advice. Some people just don't want to be interrupted. This sock works for both of you!\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:36:33.134Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
